import React from 'react'
import { Link } from 'gatsby'
import {
  Layout,
  Intro,
  SectionTitle,
  Code,
  Header,
} from '../../../../components'

import './style.scss'
import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        complete={true}
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      >
        <Intro>
          <p>
            Titles describe the main purpose of a screen and any content
            subsections in a given layout. Only use the classes with{' '}
            <span class="inline__code">{'<h1>'}</span>,{' '}
            <span class="inline__code">{'<h2>'}</span>,{' '}
            <span class="inline__code">{'<h3>'}</span> or{' '}
            <span class="inline__code">{'<h4>'}</span> elements as defined by
            context. Font size, weight and color will depend on usage, as
            defined in the variants below.
          </p>
        </Intro>
        <SectionTitle>Variants</SectionTitle>
        <div className="showcase__title l-margin-top--xxlarge">Title 1</div>
        <p>
          Use for the Title element that belongs in the first level of the
          visual hierarchy. This will usually be the headline title, which
          appears only once per page.
        </p>
        <table class="showcase-table l-margin-bottom--none">
          <thead>
            <th> </th>
            <th>Weight</th>
            <th>Color</th>
            <th>Font Values</th>
            <th>Usage</th>
          </thead>
          <tbody>
            <tr class="showcase-table__white-row">
              <td>
                <h1 class="c-title-1--normal">Title1/Normal</h1>
              </td>
              <td>SemiLight 200</td>
              <td>#007856</td>
              <td class="showcase-table__font-values">
                font-size: <strong>32px</strong>
                <br />
                line-height: <strong>40px</strong>
              </td>
              <td class="showcase-table__usage">
                For first level titles on light backgrounds
              </td>
            </tr>
          </tbody>
        </table>
        <Code
          site={data.site}
          language="html"
        >{`<h1 class="c-title-1--normal">Lorem ipsum</h1>`}</Code>

        <table class="showcase-table l-margin-bottom--none">
          <tbody>
            <tr class="showcase-table__dark-row">
              <td>
                <h1 class="c-title-1--light">Title1/Light</h1>
              </td>
              <td>SemiLight 200</td>
              <td>#FFF</td>
              <td class="showcase-table__font-values">
                font-size: <strong>32px</strong>
                <br />
                line-height: <strong>40px</strong>
              </td>
              <td class="showcase-table__usage">
                For first level titles on dark or primary green backgrounds
              </td>
            </tr>
          </tbody>
        </table>
        <Code
          site={data.site}
          language="html"
        >{`<h1 class="c-title-1--light">Lorem ipsum</h1>`}</Code>

        <div className="showcase__title l-margin-top--xxlarge">Title 2</div>
        <p>
          Use for any Title elements that belong in the second level of the
          visual hierarchy. This will usually be section header titles.
        </p>
        <table class="showcase-table l-margin-bottom--none">
          <tbody>
            <tr class="showcase-table__white-row">
              <td>
                <h2 class="c-title-2--normal">Title2/Normal</h2>
              </td>
              <td>SemiLight 200</td>
              <td>#333</td>
              <td class="showcase-table__font-values">
                font-size: <strong>24px</strong>
                <br />
                line-height: <strong>30px</strong>
              </td>
              <td class="showcase-table__usage">
                For second level titles on light backgrounds
              </td>
            </tr>
          </tbody>
        </table>
        <Code
          site={data.site}
          language="html"
        >{`<h2 class="c-title-2--normal">Lorem ipsum</h2>`}</Code>

        <table class="showcase-table l-margin-bottom--none">
          <tbody>
            <tr class="showcase-table__dark-row">
              <td>
                <h2 class="c-title-2--light">Title2/Light</h2>
              </td>
              <td>SemiLight 200</td>
              <td>#FFF</td>
              <td class="showcase-table__font-values">
                font-size: <strong>24px</strong>
                <br />
                line-height: <strong>30px</strong>
              </td>
              <td class="showcase-table__usage">
                For second level titles on dark or primary green backgrounds
              </td>
            </tr>
          </tbody>
        </table>
        <Code
          site={data.site}
          language="html"
        >{`<h2 class="c-title-2--light">Lorem ipsum</h2>`}</Code>

        <div className="showcase__title l-margin-top--xxlarge">Title 3</div>
        <p>
          Use for any Title elements that belong in the third level of the
          visual hierarchy. This will usually be section or subsection header
          titles.
        </p>
        <table class="showcase-table l-margin-bottom--none">
          <tbody>
            <tr class="showcase-table__white-row">
              <td>
                <h3 class="c-title-3--normal">Title3/Normal</h3>
              </td>
              <td>Medium 500</td>
              <td>#333</td>
              <td class="showcase-table__font-values">
                font-size: <strong>16px</strong>
                <br />
                line-height: <strong>24px</strong>
              </td>
              <td class="showcase-table__usage">
                For third level titles on light backgrounds
              </td>
            </tr>
          </tbody>
        </table>
        <Code
          site={data.site}
          language="html"
        >{`<h3 class="c-title-3--normal">Lorem ipsum</h3>`}</Code>

        <table class="showcase-table l-margin-bottom--none">
          <tbody>
            <tr class="showcase-table__dark-row">
              <td>
                <h3 class="c-title-3--light">Title3/Light</h3>
              </td>
              <td>Medium 500</td>
              <td>#FFF</td>
              <td class="showcase-table__font-values">
                font-size: <strong>16px</strong>
                <br />
                line-height: <strong>24px</strong>
              </td>
              <td class="showcase-table__usage">
                For third level titles on dark or primary green backgrounds
              </td>
            </tr>
          </tbody>
        </table>
        <Code
          site={data.site}
          language="html"
        >{`<h3 class="c-title-3--light">Lorem ipsum</h3>`}</Code>
        <div className="showcase__title l-margin-top--xxlarge">Title 4</div>
        <p>
          Use for any Title elements that belong in the fourth level of the
          visual hierarchy. One example of this is the eyebrow text on the{' '}
          <Link class="link" to={'/' + data.site + '/components/card/design'}>
            card
          </Link>{' '}
          component.
        </p>
        <table class="showcase-table l-margin-bottom--none">
          <tbody>
            <tr class="showcase-table__white-row">
              <td>
                <h4 class="c-title-4--normal">Title4/Normal</h4>
              </td>
              <td>SemiLight 200</td>
              <td>#333</td>
              <td class="showcase-table__font-values">
                font-size: <strong>12px</strong>
                <br />
                line-height: <strong>18px</strong>
                <br />
                letter-spacing: <strong>2px</strong>
              </td>
              <td class="showcase-table__usage">
                For fourth level titles on light backgrounds
              </td>
            </tr>
          </tbody>
        </table>
        <Code
          site={data.site}
          language="html"
        >{`<h4 class="c-title-4--normal">Lorem ipsum</h4>`}</Code>
        <table class="showcase-table l-margin-bottom--none">
          <tbody>
            <tr class="showcase-table__dark-row">
              <td>
                <h4 class="c-title-4--subtle">Title4/Subtle</h4>
              </td>
              <td>SemiLight 200</td>
              <td>#D7D7D7</td>
              <td class="showcase-table__font-values">
                font-size: <strong>12px</strong>
                <br />
                line-height: <strong>18px</strong>
                <br />
                letter-spacing: <strong>2px</strong>
              </td>
              <td class="showcase-table__usage">
                For fourth level titles on dark backgrounds
              </td>
            </tr>
          </tbody>
        </table>
        <Code
          site={data.site}
          language="html"
        >{`<h4 class="c-title-4--subtle">Lorem ipsum</h4>`}</Code>
        <table class="showcase-table l-margin-bottom--none">
          <tbody>
            <tr class="showcase-table__dark-row">
              <td>
                <h4 class="c-title-4--light">Title4/Light</h4>
              </td>
              <td>SemiLight 200</td>
              <td>#FFF</td>
              <td class="showcase-table__font-values">
                font-size: <strong>12px</strong>
                <br />
                line-height: <strong>18px</strong>
                <br />
                letter-spacing: <strong>2px</strong>
              </td>
              <td class="showcase-table__usage">
                For fourth level titles on dark or primary green backgrounds
              </td>
            </tr>
          </tbody>
        </table>
        <Code
          site={data.site}
          language="html"
        >{`<h4 class="c-title-4--light">Lorem ipsum</h4>`}</Code>
      </Layout>
    </>
  )
}
